import { Component } from '@angular/core';

@Component({
    selector: 'app-mb-header',
    templateUrl: './mb-header.component.html',
    styleUrl: './mb-header.component.scss'
})
export class MbHeaderComponent {

}
